
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRouteImportIec as ObiRouteImportIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-route-import-iec.js';
 
 
 

 
 export const ObiRouteImportIec = createComponent({
   react: React,
   tagName: 'obi-route-import-iec',
   elementClass: ObiRouteImportIecElement,
   events: {
     
   }
  });
 
 